"use client";

import { useToastContext } from "@/components/toast-provider";

export const useToast = () => useToastContext();

